<template>
  <div class="component-authBar">
    <span class="auth-text">{{token ? '您尚未绑定淘宝账号' : '登录后享受更多优惠'}}</span>
    <span class="btn-auth" @click="handleClickBindTb()">{{token ? '立即绑定' : '立即登录'}}</span>
  </div>
</template>

<script>
import Consts from '@/common/consts'
import { isWeiXin } from '@/utils/help'
import LoginService from '@/services/login'
import _AP from '@/utils/ap'
import { mapGetters } from 'vuex'
export default {
  name: 'authBar',
  computed: {
    ...mapGetters([
      'token'
    ])
  },
  methods: {
    /**
     * 点击绑定淘宝账号
     */
    handleClickBindTb() {
      if (this.token) {
        const authURL = LoginService.getTaobaoAuthUrl()
        if (isWeiXin()) {
          _AP.redirect(`https://pub.${Consts.WAP_HOST}/wx_jump_taobao.htm`, authURL)
        } else {
          window.location.href = authURL
        }
      } else {
        this.$router.push({ name: 'login' })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.component-authBar {
  position: fixed;
  display: flex;
  align-items: center;
  padding: 0 0.2rem 0 0.3rem;
  bottom: 1rem;
  left: 0;
  right: 0;
  height: 0.8rem;
  background: rgba(26,26,26,.8);
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.05);
  z-index: 11;
  .auth-text {
    color: #f5d88e;
    font-size: 0.28rem;
    font-weight: 500;
  }
  .btn-auth {
    display: inline-block;
    margin-left: auto;
    color: #444444;
    background: #f5d88e;
    padding: 0.1rem 0.4rem;
    border-radius: 0.4rem;
    &:active {
      opacity: 0.3;
    }
  }
}
</style>
